import React, { FC } from 'react'

export interface IArrowRightIconProps {
  className?: string
}

export const ArrowRightIcon: FC<IArrowRightIconProps> = ({ className = '' }) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <line x1="2" y1="8" x2="14" y2="8" />
    <polyline points="9 3 14 8 9 13" />
  </svg>
)

export default ArrowRightIcon
